"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var currency_js_1 = __importDefault(require("currency.js"));
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var store_credit_1 = require("../../../../../misc/store-credit");
var action_sheet_1 = __importDefault(require("../../../../../plugins/action-sheet"));
var tooltip_1 = __importDefault(require("../../../../../plugins/tooltip"));
var api_1 = require("../../../api");
var bundle_components_1 = __importDefault(require("../../../bundle-components"));
var process_charge_1 = require("../../../mutations/process-charge");
var utils_1 = require("../../../utils");
var bundle_items_1 = __importDefault(require("../components/bundle-items"));
var BUNDLE_SAVINGS_THRESHOLD = 4;
var OrderNowModal = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var groupedSubscription = _a.subscription, customerData = _a.customerData;
    var orderNowSettings = window.accountApp.settings.shipNowModal;
    var bundleComponents = new bundle_components_1.default(groupedSubscription);
    var _h = bundleComponents.getComponents(), diaperBundleItems = _h.diaperBundleItems, extraItems = _h.extraItems, vitaminBundleItems = _h.vitaminBundleItems, essentialsBundleItems = _h.essentialsBundleItems;
    var bundleItem = bundleComponents.getBundleVariant();
    var bundleType = bundleComponents.getBundleType();
    var _j = __read((0, react_1.useState)(false), 2), isModalOpen = _j[0], setModalVisibility = _j[1];
    var _k = __read((0, react_1.useState)(false), 2), areBundleDetailsExpanded = _k[0], setBundleDetailsExpanded = _k[1];
    var _l = __read((0, react_1.useState)(), 2), orderNumber = _l[0], setOrderNumber = _l[1];
    var address = groupedSubscription.address;
    var queryClient = (0, react_query_1.useQueryClient)();
    var containsOOSItem = bundleComponents.containsOutOfStockItem();
    var _m = (0, react_query_1.useMutation)('processCharge', function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(process_charge_1.PROCESS_CHARGE, variables); }), processChargeMutation = _m.mutateAsync, processingCharge = _m.isLoading, isError = _m.isError;
    var upcomingCharge = groupedSubscription.futureCharge;
    var itemTotal = Number(upcomingCharge === null || upcomingCharge === void 0 ? void 0 : upcomingCharge.total_line_items_price);
    var totalDiscounts = Number(upcomingCharge === null || upcomingCharge === void 0 ? void 0 : upcomingCharge.total_discounts);
    var subtotal = Number(upcomingCharge === null || upcomingCharge === void 0 ? void 0 : upcomingCharge.total_price);
    var bundleSavings = Number(groupedSubscription.bundleSavings);
    var isLoggedIn = !!((_b = window.customer) === null || _b === void 0 ? void 0 : _b.id);
    var customerCreditAccountQuery = (0, store_credit_1.useCustomerCreditAccount)({ enabled: !!isLoggedIn });
    var customerStoreCreditBalance = ((_c = customerCreditAccountQuery.data) === null || _c === void 0 ? void 0 : _c.account.creditAccount) ? Number(customerCreditAccountQuery.data.account.creditAccount.available_balance) : 0;
    var processCharge = function () { return __awaiter(void 0, void 0, void 0, function () {
        var daysDiff, response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    daysDiff = upcomingCharge ? (0, date_fns_1.differenceInDays)(new Date(upcomingCharge === null || upcomingCharge === void 0 ? void 0 : upcomingCharge.scheduled_at), new Date()) : 0;
                    return [4 /*yield*/, processChargeMutation({ subscriptionId: groupedSubscription.subscription.id })];
                case 1:
                    response = _b.sent();
                    setOrderNumber(response.processCharge.name);
                    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'account__orderNowProcessed', bundleType: bundleType, subtotal: subtotal, daysDiff: daysDiff });
                    return [2 /*return*/];
            }
        });
    }); };
    function showSheet() {
        var _a;
        if (upcomingCharge) {
            var daysDiff = (0, date_fns_1.differenceInDays)(new Date(upcomingCharge === null || upcomingCharge === void 0 ? void 0 : upcomingCharge.scheduled_at), new Date());
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'account__orderNowShow', bundleType: bundleType, subtotal: subtotal, daysDiff: daysDiff });
        }
        setModalVisibility(true);
    }
    var paymentImgSrc = (function () {
        var pay = customerData.payment_information;
        if (!pay)
            return undefined;
        if (pay.type === 'paypal')
            return pay.image_url;
        switch (pay.brand) {
            case 'visa':
                return window.accountApp.iconUrls.visa;
            case 'mastercard':
                return window.accountApp.iconUrls.masterCard;
            case 'discover':
                return window.accountApp.iconUrls.discover;
            case 'american-express':
                return window.accountApp.iconUrls.amex;
            default:
                return pay.image_url;
        }
    })();
    (0, react_1.useEffect)(function () { return (0, utils_1.hideThirdPartyButtons)(); });
    var handleClose = function () {
        setModalVisibility(false);
        if (orderNumber)
            queryClient.invalidateQueries('getCustomerSubscriptions');
    };
    var lastChargeProcessedAtDate = groupedSubscription.lastCharge ? (0, date_fns_tz_1.toDate)(groupedSubscription.lastCharge.processed_at, { timeZone: utils_1.RECHARGE_2021_01_TIMEZONE }) : undefined;
    var lastChargeOccurredWithinTheLast7Days = false;
    if (lastChargeProcessedAtDate) {
        var sevenDaysAgoDate = (0, date_fns_1.subDays)(new Date(), 7);
        lastChargeOccurredWithinTheLast7Days = (0, date_fns_1.isAfter)(lastChargeProcessedAtDate, sevenDaysAgoDate);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(action_sheet_1.default, { isOpen: isModalOpen, handleClose: handleClose, className: 'padding-4', style: { content: { paddingTop: '1.5em', paddingRight: '1em', paddingBottom: '7em', paddingLeft: '1em' } } },
            react_1.default.createElement("div", null,
                !orderNumber && (react_1.default.createElement("div", null,
                    react_1.default.createElement("h4", null, orderNowSettings.buttonCTA),
                    !containsOOSItem && react_1.default.createElement("p", { className: 'margin-top-4 font-size-small font-lighter' }, orderNowSettings.modalText),
                    react_1.default.createElement("div", { className: 'margin-top-4' }),
                    containsOOSItem && react_1.default.createElement("div", { className: 'alert alert--error' }, "Your bundle contains one or more out of stock items. Please remove them before ordering."),
                    lastChargeProcessedAtDate && lastChargeOccurredWithinTheLast7Days && (react_1.default.createElement("div", { className: 'alert alert--warning margin-top-4 margin-bottom-4' },
                        react_1.default.createElement("img", { src: (_e = (_d = window.bundlerApp) === null || _d === void 0 ? void 0 : _d.iconUrls) === null || _e === void 0 ? void 0 : _e.warning, className: 'margin-right-1', style: { filter: 'invert(1)' } }),
                        "The last order for this bundle was placed ",
                        (0, date_fns_1.formatDistanceToNow)(lastChargeProcessedAtDate, { addSuffix: true }),
                        ".")),
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('cart--bundle-item-container font-size-small font-lighter', { expanded: areBundleDetailsExpanded, collapsed: !areBundleDetailsExpanded }) },
                        react_1.default.createElement("div", { className: 'cart--bundle-item-info' },
                            react_1.default.createElement("img", { src: bundleItem.imgSrc, width: 70 }),
                            react_1.default.createElement("div", { className: 'cart--bundle-item-title' },
                                react_1.default.createElement("div", { className: 'font-size-14 font-weight-500' }, bundleItem.title),
                                react_1.default.createElement("span", { className: 'text-wisteria font-weight-500 margin-bottom-2' },
                                    "$",
                                    subtotal.toFixed(2)),
                                bundleSavings > BUNDLE_SAVINGS_THRESHOLD && (react_1.default.createElement("div", { className: 'font-size-small font-lighter' },
                                    react_1.default.createElement("i", null,
                                        "You will save $",
                                        groupedSubscription.bundleSavings,
                                        " by bundling"))))),
                        react_1.default.createElement("div", { className: (0, classnames_1.default)('cart--bundle-details', { expanded: areBundleDetailsExpanded, collapsed: !areBundleDetailsExpanded }) }, (function () {
                            if (bundleType === 'Vitamin')
                                return react_1.default.createElement(bundle_items_1.default, { items: vitaminBundleItems });
                            if (bundleType === 'Fundamentals')
                                return react_1.default.createElement(bundle_items_1.default, { items: essentialsBundleItems });
                            if (bundleType === 'Diaper' || bundleType === 'Training Pant')
                                return (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(bundle_items_1.default, { items: diaperBundleItems, supressLowStockMessage: true }),
                                    !!extraItems.length && react_1.default.createElement(bundle_items_1.default, { items: extraItems, supressLowStockMessage: true })));
                            return;
                        })()),
                        react_1.default.createElement("button", { className: 'cart--bundle--item__show-more', onClick: function () { return setBundleDetailsExpanded(true); } },
                            "See Bundle Details ",
                            react_1.default.createElement("img", { src: orderNowSettings.arrowDownIconURL })),
                        react_1.default.createElement("button", { className: 'cart--bundle--item__show-less', onClick: function () { return setBundleDetailsExpanded(false); } },
                            "Hide Bundle Details ",
                            react_1.default.createElement("img", { src: orderNowSettings.arrowUpIconURL }))),
                    react_1.default.createElement("div", { className: 'bordered border-very-light-pink padding-6 margin-top-6' },
                        react_1.default.createElement("h6", null, "Shipping Address"),
                        react_1.default.createElement("p", { className: 'font-lighter font-size-small text-brownish-grey margin-bottom-0' },
                            address.address1,
                            ' ',
                            address.address2 && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("br", null),
                                address.address2)),
                            react_1.default.createElement("br", null),
                            address.city,
                            ", ",
                            address.province,
                            " ",
                            address.zip)),
                    customerData.payment_information && (react_1.default.createElement("div", { className: 'bordered border-very-light-pink padding-6 margin-top-6' },
                        react_1.default.createElement("h6", null, "Payment Method"),
                        react_1.default.createElement("p", { className: 'font-lighter font-size-small text-brownish-grey margin-bottom-0' },
                            react_1.default.createElement("img", { src: paymentImgSrc, width: 50, className: 'margin-right-4' }),
                            ((_f = customerData.payment_information) === null || _f === void 0 ? void 0 : _f.type) === 'paypal' && customerData.payment_information.email,
                            ((_g = customerData.payment_information) === null || _g === void 0 ? void 0 : _g.type) !== 'paypal' && "ending in ".concat(customerData.payment_information.last4)))),
                    upcomingCharge && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: 'margin-top-4' },
                            react_1.default.createElement("div", { className: 'grid-x font-size-small font-lighter' },
                                react_1.default.createElement("div", { className: 'cell small-6 text-left font-weight-500' }, totalDiscounts === 0 ? "Subtotal" : "Item total"),
                                react_1.default.createElement("div", { className: 'cell small-6 text-right' },
                                    "$",
                                    itemTotal.toFixed(2))),
                            totalDiscounts !== 0 && (react_1.default.createElement("div", { className: 'grid-x font-size-small font-lighter' },
                                react_1.default.createElement("div", { className: 'cell small-6 text-left font-weight-500 text-wisteria' }, "Discount"),
                                react_1.default.createElement("div", { className: 'cell small-6 text-right text-wisteria' },
                                    "- $",
                                    totalDiscounts.toFixed(2)))),
                            totalDiscounts !== 0 && (react_1.default.createElement("div", { className: 'grid-x font-size-small font-lighter' },
                                react_1.default.createElement("div", { className: 'cell small-6 text-left font-weight-500' }, "Subtotal"),
                                react_1.default.createElement("div", { className: 'cell small-6 text-right font-bold' },
                                    "$",
                                    subtotal.toFixed(2)))),
                            react_1.default.createElement("div", { className: 'font-size-small font-lighter text-right' }, "Plus taxes and shipping."),
                            customerStoreCreditBalance > 0 && (react_1.default.createElement("div", { className: 'font-size-small font-lighter' },
                                "Your Store Credit will automatically apply.",
                                react_1.default.createElement(tooltip_1.default, { button: react_1.default.createElement("i", { className: 'ss-info padding-left-1 font-size-small font-lighter', style: { verticalAlign: 'middle' } }) },
                                    react_1.default.createElement("div", { className: 'padding-3 font-size-small font-lighter', style: { margin: 0 } },
                                        "You have ",
                                        react_1.default.createElement("span", { className: 'font-bold' },
                                            "$",
                                            (0, currency_js_1.default)(customerStoreCreditBalance).toString()),
                                        " in Store Credit available."))))))),
                    isError && (react_1.default.createElement("div", { className: 'margin-top-4 alert alert--error' }, "An error occurred when processing your order. Please contact customer service to assist with your request.")),
                    react_1.default.createElement("div", { className: 'text-center modal--action-sheet__buttons' },
                        react_1.default.createElement("button", { className: 'button btn-form margin-bottom-2', onClick: function () { return processCharge(); }, disabled: processingCharge || containsOOSItem },
                            processingCharge && react_1.default.createElement("img", { src: orderNowSettings.spinner, style: { width: '1em', height: '1em' }, className: 'margin-right-1' }),
                            processingCharge ? "Please Wait..." : orderNowSettings.confirmButtonText),
                        !processingCharge && (react_1.default.createElement("button", { onClick: function () { return setModalVisibility(false); }, className: 'font-size-small font-lighter text-center' }, orderNowSettings.cancelButtonText)),
                        processingCharge && react_1.default.createElement("div", { className: 'font-size-small font-lighter text-center' }, "Do not close this window.")))),
                orderNumber && (react_1.default.createElement("div", { className: 'text-center' },
                    react_1.default.createElement("img", { src: orderNowSettings.orderConfirmationImg, className: 'padding-8 margin-bottom-4 hide-for-medium' }),
                    react_1.default.createElement("img", { src: orderNowSettings.orderConfirmationImg, className: 'padding-8 margin-bottom-4 width-50 show-for-medium' }),
                    react_1.default.createElement("p", { className: 'font-lighter font-size-small margin-bottom-4' },
                        "Yay! Your order number is ",
                        react_1.default.createElement("b", null, orderNumber),
                        ". ",
                        orderNowSettings.confirmationText),
                    react_1.default.createElement("button", { onClick: function () { return handleClose(); }, className: 'button btn-form' }, "Done"))))),
        react_1.default.createElement("button", { className: 'button btn margin-top-4 margin-right-2', onClick: function () { return showSheet(); }, disabled: processingCharge }, orderNowSettings.buttonCTA)));
};
exports.default = OrderNowModal;
